module.exports = __webpack_public_path__ + "static/media/De-Montfort-University-logo.4faea83c.png";